import { render, staticRenderFns } from "./SearchMessage.vue?vue&type=template&id=79d0e35e"
import script from "./SearchMessage.vue?vue&type=script&lang=ts"
export * from "./SearchMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports